import { useState, useCallback } from "react";
import type { Position } from "./types";

export const useContextMenu = () => {
    const [show, setShow] = useState(false);
    const [position, setPosition] = useState<Position>({ x: 0, y: 0 });

    const handleContextMenu = useCallback((e: React.MouseEvent) => {
        e.preventDefault();
        setPosition({ x: e.pageX, y: e.pageY });
        setShow(true);
    }, []);

    const hideContextMenu = useCallback(() => {
        setShow(false);
    }, []);

    return {
        show,
        position,
        handleContextMenu,
        hideContextMenu,
    };
};
